import styled from 'styled-components';

interface StyledProps {
  index: number;
  isRectangleBox?: boolean;
  unGroup?: boolean;
  lineGroup?: boolean;
}

export const Container: any = styled.div`
  display: flex;
  flex-direction: row;
`;

export const Icon = styled.span.attrs<any, StyledProps>((): any => ({}))`
  font-size: 10px;
  color: ${({ theme }) => theme.groupList.groupUsers};
  width: 24px;
  height: 24px;
  border-radius: 16px;
  border: solid 2px ${({ theme }) => theme.cardGroup.groupUsers.border};
  background-color: ${({ theme }) => theme.cardGroup.groupUsers.background};

  ${({ isRectangleBox, index }) => {
    if (isRectangleBox) {
      return `
        width: 75px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        text-align: center;
        padding: 0 5px;
        margin-left: 0;
      `;
    }
    return `
      display: flex;
      position: relative;
      align-items: center;
      justify-content: center;
      border-radius: 100%;
      margin-left: ${index !== 0 ? '-8px' : '0'};
      `;
  }}
`;

export const MoreUsers = styled.span.attrs<any, StyledProps>((): any => ({}))`
  display: flex;
  position: relative;
  align-items: center;
  justify-content: center;

  width: 24px;
  height: 24px;
  font-size: 10px;
  line-height: 1.6;
  color: ${({ theme }) => theme.cardGroup.groupUsers};

  border-radius: 16px;
  border: solid 2px ${({ theme }) => theme.cardGroup.groupUsers.border};
  background-color: ${({ theme }) => theme.cardGroup.groupUsers};

  margin-left: ${({ unGroup, lineGroup }) => (unGroup || lineGroup ? '0' : '-8px')};
`;
